import React from "react";
import logo from "./../../assets/img/logo-footer.png";

const Navbar = () => {
    return (
        <nav className="navbar fixed-top navbar-expand-lg p-0">
            <div className="container-fluid py-2">
                <a className="navbar-brand p-0 m-0" href="#"><img src={logo} className="logo" alt="we contain" /></a>
                <button className="navbar-dark navbar-toggler" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span className=" navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto ul_list">
                        <li className="li nav-item " data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                            <a className="home-item nav-link" href="#">
                                <p className="titles m-0">Home</p>
                            </a>
                        </li>
                        <li className="li nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                            <a className=" nav-link " href="#productos">
                                <p className="titles m-0">Containers</p> 
                            </a>
                        </li>
                        <li className="li nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                            <a className=" nav-link" href="#sobre">
                                <p className="titles m-0">Nosotros</p>
                            </a>
                        </li>
                        <li className="li nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                            <a className=" nav-link " href="#contacto">
                                <p className="titles m-0 ">Contacto</p>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default Navbar;